import { Form, FormikProps } from "formik";
import { memo } from "react";
import classnames from "classnames";

import { FormikInput } from "components/FormikInput";
import { Button } from "components/Button";
import { FormikTextarea } from "components/FormikTextarea";
import { FormikRadioButtonField } from "components/FormikRadioButtonField";
import { URGENCY_OPTIONS, FIELD_NAMES } from "./AskAQuestion.constanst";
import { ValuesType } from "./AskAQuestion.types";
import { preventEnterSubmit } from "utils";

interface IProps extends FormikProps<ValuesType> {
  onHide: () => void;
}

function AskAQuestionForm({ status, setFieldValue, values, onHide }: IProps) {
  return (
    <Form onKeyDown={preventEnterSubmit} className="flex flex-col">
      <div className="">
        <FormikInput
          name={FIELD_NAMES.NAME}
          label="Name"
          placeholder="E.g. John Nollan"
          className="mt-1"
          // require
        />
        <FormikInput
          name={FIELD_NAMES.EMAIL}
          label="Email"
          placeholder="E.g. johnnollan@example.com"
          className="mt-3"
          // require
        />
        <FormikTextarea
          name={FIELD_NAMES.QUESTION}
          label="Your Question"
          placeholder=""
          className="pb-4 mt-3"
          style={{ height: "160px" }}
        />

        <FormikRadioButtonField
          inlineLabel="Urgency:"
          name={FIELD_NAMES.URGENCY}
          onChange={(e) => setFieldValue(FIELD_NAMES.URGENCY, e.target.value)}
          options={URGENCY_OPTIONS}
          value={values[FIELD_NAMES.URGENCY]}
          className="pb-2"
          classNames={{
            inlineLabel: "text-[#98A0A6] text-[16px] !font-normal",
            message: "text-red-400",
            inputWrapper: "ml-4 whitespace-nowrap",
            input: "pl-0",
          }}
        />

        <div className="flex items-center xs:flex-row flex-col mt-4 w-[100%]">
          <Button
            customPaddings
            type="button"
            className="flex basis-1 grow justify-center items-center text-center rounded-[4px] border border-primaryBlue text-primaryBlue h-[40px] hover:bg-primaryBlue hover:text-white xs:mt-0 mt-4 px-6"
            onClick={onHide}
          >
            Cancel
          </Button>

          <Button
            disabled={status?.loading}
            type="submit"
            className={classnames(
              "flex basis-1 grow justify-center items-center text-center rounded-[4px] h-[40px] text-white rounded bg-primaryBlue hover:bg-[#3383B0]  xs:ml-6 xs:mt-0 mt-4",
              {
                "bg-gray-300 pointer-events-none": status?.loading,
              }
            )}
          >
            Send
          </Button>
        </div>
      </div>
    </Form>
  );
}

export default memo(AskAQuestionForm);
